import script from "./AppWelcome.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppWelcome.vue?vue&type=script&lang=ts&setup=true"

import "./AppWelcome.vue?vue&type=style&index=0&id=17cd2b8b&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17cd2b8b"]])

export default __exports__